import { Limits } from "@/types/billing";
import { Workspace } from "@/types/workspace";

export const allowLimit = (
  workspace: Workspace,
  limit: keyof Limits,
  value: number | boolean
) => {
  const maxLimit = workspace.active_subscription.plan?.limits[limit];
  if (maxLimit) {
    if (typeof maxLimit === "boolean") {
      return maxLimit;
    } else if (maxLimit === -1) {
      return true;
    } else if (typeof value === "number" && maxLimit > value) {
      return true;
    }
  }
  return false;
};
